import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import ArrayList from '../../../../java/util/ArrayList';
var PriorityQueue = /*#__PURE__*/function () {
  function PriorityQueue() {
    _classCallCheck(this, PriorityQueue);
    PriorityQueue.constructor_.apply(this, arguments);
  }
  _createClass(PriorityQueue, [{
    key: "poll",
    value: function poll() {
      if (this.isEmpty()) return null;
      var minItem = this._items.get(1);
      this._items.set(1, this._items.get(this._size));
      this._size -= 1;
      this.reorder(1);
      return minItem;
    }
  }, {
    key: "size",
    value: function size() {
      return this._size;
    }
  }, {
    key: "reorder",
    value: function reorder(hole) {
      var child = null;
      var tmp = this._items.get(hole);
      for (; hole * 2 <= this._size; hole = child) {
        child = hole * 2;
        if (child !== this._size && this._items.get(child + 1).compareTo(this._items.get(child)) < 0) child++;
        if (this._items.get(child).compareTo(tmp) < 0) this._items.set(hole, this._items.get(child));else break;
      }
      this._items.set(hole, tmp);
    }
  }, {
    key: "clear",
    value: function clear() {
      this._size = 0;
      this._items.clear();
    }
  }, {
    key: "peek",
    value: function peek() {
      if (this.isEmpty()) return null;
      var minItem = this._items.get(1);
      return minItem;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._size === 0;
    }
  }, {
    key: "add",
    value: function add(x) {
      this._items.add(null);
      this._size += 1;
      var hole = this._size;
      this._items.set(0, x);
      for (; x.compareTo(this._items.get(Math.trunc(hole / 2))) < 0; hole /= 2) this._items.set(hole, this._items.get(Math.trunc(hole / 2)));
      this._items.set(hole, x);
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._size = null;
      this._items = null;
      this._size = 0;
      this._items = new ArrayList();
      this._items.add(null);
    }
  }]);
  return PriorityQueue;
}();
export { PriorityQueue as default };